import Vue from 'vue'
import Meta from 'vue-meta'

Vue.use(Meta)

export default Meta



// WEBPACK FOOTER //
// ./src/vendor/vue-meta.js